import React from "react";
import {
  AddFlex,
  CustomText,
  SecondaryActionButton,
} from "../Components/reusableStyles";
import { EditOutlined } from "@mui/icons-material";
import {
  primaryActionColor,
  primaryActionColorLight,
} from "../utils/constants";
import { Currency, formatPrice, isNullOrUndefined } from "../utils/utils";

function PlanCard({ plan, onPlanSelected, isMonthly }) {
  const { name, subText, isFree, prices, featureText } = plan;
  return (
    <AddFlex
      width="30%"
      flexDirection="column"
      borderRadius="12px"
      style={{ boxShadow: "0px 0px 12px 1px rgba(0, 0, 0, 0.1)" }}
    >
      <AddFlex
        flexDirection="column"
        gap="6px"
        backgroundColor={primaryActionColorLight}
        padding="20px"
        borderRadius="12px 12px 0 0"
      >
        <AddFlex alignItems="center" gap="12px">
          <CustomText
            fontSize="24px"
            color={primaryActionColor}
            fontWeight="600"
            style={{ letterSpacing: "-0.48px" }}
          >
            {name}
          </CustomText>
          <EditOutlined
            onClick={onPlanSelected}
            sx={{
              fontSize: "20px",
              color: primaryActionColor,
              cursor: "pointer",
            }}
          />
        </AddFlex>
        <CustomText fontSize="14px" color={primaryActionColor} fontWeight="300">
          {subText}
        </CustomText>
        <AddFlex margin="15px 0 0 0" flexDirection="column">
          {!isNullOrUndefined(prices) && !isFree ? (
            <CustomText fontSize="12px" color={primaryActionColor}>
              Starting at{" "}
              <span style={{ textDecoration: "line-through" }}>
                {formatPrice(
                  prices[isMonthly ? "monthly" : "annualy"][Currency.INR][
                    "strike"
                  ],
                  [Currency.INR]
                )}
              </span>
            </CustomText>
          ) : (
            <CustomText fontSize="12px" color={"transparent"}>
              Starting
            </CustomText>
          )}
          <CustomText color={primaryActionColor} fontSize="22px">
            {isFree
              ? "FREE"
              : formatPrice(
                  prices[isMonthly ? "monthly" : "annualy"][Currency.INR][
                    "main"
                  ],
                  [Currency.INR]
                )}
          </CustomText>
        </AddFlex>
      </AddFlex>
      <AddFlex
        grow="1"
        dangerouslySetInnerHTML={{
          __html: featureText,
        }}
        padding="20px"
        flexDirection="column"
      ></AddFlex>
      <SecondaryActionButton margin="20px">Choose {name}</SecondaryActionButton>
    </AddFlex>
  );
}

export default PlanCard;
